import { GTM_EVENTS } from '@/constants/gtm';
import { OPTIMIZELY_PAGES } from '@/constants/optimizely';
import { GET_STARTED_MODAL_HASH } from '@/constants/routes';
import { GlobalContext } from '@/context';
import { createLogger } from '@/lib/debug';
import gtm from '@/lib/gtm';
import optimizely from '@/lib/optimizely';
import { useRouter } from 'next/router';
import { FC, useContext, useEffect } from 'react';
import DemoModalContent from '../DemoModal/DemoModalContent';

const logger = createLogger('get started modal');

interface GetStartedModalProps {
  onClose?: () => void;
}

const GetStartedModal: FC<GetStartedModalProps> = ({ onClose }) => {
  const router = useRouter();
  const { toggleGetStartedModal } = useContext(GlobalContext);

  useEffect(() => {
    gtm.event(GTM_EVENTS.GET_STARTED_MODAL_OPENED);

    const deactivate = optimizely.activatePage(OPTIMIZELY_PAGES.ANY_GET_STARTED_MODAL);

    const [currentPath, currentHash] = router.asPath.split('#');

    if (currentHash !== GET_STARTED_MODAL_HASH) {
      /* Weird hack because useRouterEvents doesn't pick this change up */
      setTimeout(() => {
        try {
          router.push(`${currentPath}#${GET_STARTED_MODAL_HASH}`, undefined, {
            shallow: true,
            scroll: false,
          });
        } catch (e) {
          // Workaround for https://github.com/vercel/next.js/issues/37362
          if (!e.cancelled) throw e;
        }
      }, 0);
    }

    return () => {
      deactivate();

      gtm.event(GTM_EVENTS.GET_STARTED_MODAL_CLOSED);

      const [pathName] = currentPath.split('?');

      if (pathName === window.location.pathname) {
        logger.log('On the same path as when opened, removing hash...');

        try {
          /* Weird hack because useRouterEvents doesn't pick this change up */
          setTimeout(() => {
            router.push(currentPath, undefined, {
              shallow: true,
              scroll: false,
            });
          }, 0);
        } catch (e) {
          // Workaround for https://github.com/vercel/next.js/issues/37362
          if (!e.cancelled) throw e;
        }
      } else {
        logger.log('Not on the same path as when opened, not attempting to remove URL hash');
      }
    };
  }, []);

  return (
    <DemoModalContent router={router} onClose={() => {
        toggleGetStartedModal(false);
        if (onClose) onClose();
      }} />
  );
};

export default GetStartedModal;
